import React, { Component } from 'react';
import nullToEmpty from "utils/nullToEmpty";
import moment from 'moment';
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import { Dialog } from '@headlessui/react';
import { customizeSVG } from 'utils/customizeSVG.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as employees from "store/entities/employees/action";


class Modal extends Component {
    constructor(props) {
        super(props);
        this.completeButtonRef = React.createRef(null);
    }
    

    state = { 
        manageEarningsParams: {
            employeeId: "",
            employeeName: "",
            stopEarnings: "",
            stopEarningType: "",
            stopEarningFrom: "",
            stopEarningTo: "",
        },
        showScheduleStopEarnings: false,
    }

    
    formChangeManageEarnings = (e) => {
        const formValue = {...this.state.manageEarningsParams};
        if (e.currentTarget.name === "stopEarnings"){
            formValue[e.currentTarget.name] = (e.currentTarget.value === "true");
        }
        else{
            formValue[e.currentTarget.name] = e.currentTarget.value;
        }
        this.setState({manageEarningsParams: formValue});
    }


    toggleScheduleStopEarnings = (action) => {
        let manageEarningsParams = {};

        if (action === false){
            manageEarningsParams = {
                ...this.state.manageEarningsParams,
                stopEarningType: "instant",
            }
        }
        else{
            manageEarningsParams = {
                ...this.state.manageEarningsParams,
                stopEarningType: "scheduled",
            }
        }

        this.setState({showScheduleStopEarnings: action, manageEarningsParams});
    }


    submitManageEarnings = async e => {
        e.preventDefault();
        const { manageEarningsParams } = this.state;
        // alert("submitted");
        // console.log("manageEarningsParams", manageEarningsParams);
        let errors = 0;
        
        if (manageEarningsParams.stopEarnings === true){
            if (manageEarningsParams.stopEarningType === "scheduled"){
                if (manageEarningsParams.stopEarningFrom === null){
                    toast.error("Please select a start date");
                    errors++;
                }
            }
        }

        if (errors === 0){
            if (manageEarningsParams.stopEarnings === false){
                // alert("resume");
                this.props.resumeEmployeeEarning(manageEarningsParams.employeeId).then(() => {
                    this.props.handleToggleManageEarnings(false);
                    this.props.reloadData();
                });
            }
            else{
                // alert("stop");
                let params = {
                    type: manageEarningsParams.stopEarningType,
                    startDate: manageEarningsParams.stopEarningFrom,
                    endDate: manageEarningsParams.stopEarningTo,
                }
                if (params.endDate === null){
                    delete params['endDate'];
                }
                this.props.stopEmployeeEarning(manageEarningsParams.employeeId, params).then(() => {
                    this.props.handleToggleManageEarnings(false);
                    this.props.reloadData();
                });
            }
        }
    }
    

    componentDidUpdate(prevProps, prevState, snapshot){
        const { employee } = this.props;
        
        if (prevProps.employee !== employee){
            if (Object.keys(employee).length > 0){
                const manageEarningsParams = {
                    employeeId: employee._id,
                    employeeName: employee.fullName,
                    stopEarnings: ((employee.stopEarningFrom === null) ? employee.stopEarning : true),
                    stopEarningType: ((employee.stopEarningFrom === null) ? "instant" : "scheduled"),
                    stopEarningFrom: employee.stopEarningFrom,
                    stopEarningTo: ((employee.stopEarningTo === "Invalid date") ? "" : employee.stopEarningTo),
                }
                const showScheduleStopEarnings = ((manageEarningsParams.stopEarningType === "instant") ? false : true);
                this.setState({manageEarningsParams, showScheduleStopEarnings});
            }
        }

    }

    
    render() { 
        customizeSVG();
        const { manageEarningsParams, showScheduleStopEarnings } = this.state;
        const { isOpen } = this.props;
        const { employeeStopEarningsLoading, employeeResumeEarningsLoading } = this.props;

        return (
            <div>

                
                
                {(isOpen === true) &&
                    <Dialog open={isOpen} initialFocus={this.completeButtonRef} onClose={() => this.props.handleToggleManageEarnings(false)} className="fixed z-10 inset-0 overflow-y-auto">
                        <div className="flex items-center justify-center min-h-screen">
                            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

                            <div className="w-full max-w-lg mx-auto relative bg-white rounded overflow-hidden">
                                <div className="h-12 px-4 bg-ep-primary flex justify-between overflow-hidden">
                                    <div className="my-auto text-white">
                                        Manage Earnings
                                    </div>
                                    <div onClick={() => this.props.handleToggleManageEarnings(false)} ref={this.completeButtonRef} className="w-7 h-7 flex my-auto border group hover:bg-red-400 hover:border-red-400 border-white rounded-lg cursor-pointer">
                                        <FontAwesomeIcon icon="times" className="text-white m-auto" />
                                    </div>
                                </div>

                                <form className="p-6" onSubmit={this.submitManageEarnings}>

                                    <div>
                                        Employee:&nbsp;
                                        <span className="font-bold">
                                            {manageEarningsParams.employeeName}
                                        </span>
                                    </div>

                                    <div className="mt-4">

                                        <div className="w-full block">
                                            <label className="px-6 py-3 flex justify-between rounded-lg shadow-sm border border-gray-200 cursor-pointer hover:bg-gray-100">
                                                <div className="flex space-x-4">
                                                    <input type="radio"
                                                        checked={ manageEarningsParams.stopEarnings === false } 
                                                        onChange={this.formChangeManageEarnings}
                                                        name="stopEarnings"
                                                        value={false}
                                                        className="form-radio my-auto"
                                                        /> 
                                                    <div className="my-auto">
                                                        Allow employee to earn on Earnipay
                                                    </div>
                                                </div>
                                            </label>
                                        </div>

                                        <div className="mt-4 w-full block bg-white relative z-10">
                                            <label className="px-6 py-3 flex justify-between rounded-lg shadow-sm border border-gray-200 cursor-pointer hover:bg-gray-100">
                                                <div className="flex space-x-4">
                                                    <input type="radio"
                                                        checked={ manageEarningsParams.stopEarnings === true } 
                                                        onChange={this.formChangeManageEarnings}
                                                        name="stopEarnings"
                                                        value={true}
                                                        className="form-radio my-auto"
                                                        /> 
                                                    <div className="my-auto">
                                                        Stop employee from earning on Earnipay
                                                    </div>
                                                </div>
                                            </label>
                                        </div>

                                        {(manageEarningsParams.stopEarnings === true) &&
                                            <div className="border p-6 pt-8 -mt-2">

                                                <div className="hidden grid grid-cols-2 gap-x-4">
                                                    <button type="button" className={"btn btn-block " + ((!showScheduleStopEarnings) ? "btn-ep-secondary" : "btn-transparent-black btn-disabled-30")} onClick={this.runPayrollRightAway} disabled={this.props.payrollRunLoading || showScheduleStopEarnings}>
                                                        <FontAwesomeIcon icon="circle-notch" spin className={"text-xl mr-2 " + (this.props.payrollRunLoading?"inline":"hidden")} />
                                                        Right away
                                                    </button>
                                                    <button type="button" className="btn btn-transparent-black btn-block" onClick={this.toggleScheduleStopEarnings} disabled={this.props.payrollRunLoading}>
                                                        Schedule a date
                                                        <FontAwesomeIcon icon={(showScheduleStopEarnings) ? "angle-up" : "angle-down"} className="ml-2 text-lg" />
                                                    </button>
                                                </div>

                                                <div className="ml-8">
                                                    <div className="w-full block">
                                                        <label className="px-6 py-3 flex justify-between rounded-lg shadow-sm border border-gray-200 cursor-pointer hover:bg-gray-100">
                                                            <div className="flex space-x-4">
                                                                <input type="radio"
                                                                    checked={ showScheduleStopEarnings === false } 
                                                                    onChange={() => this.toggleScheduleStopEarnings(false)}
                                                                    value={false}
                                                                    className="form-radio my-auto"
                                                                    /> 
                                                                <div className="my-auto">
                                                                    Right Away
                                                                </div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    <div className="mt-4 w-full block bg-white relative z-10">
                                                        <label className="px-6 py-3 flex justify-between rounded-lg shadow-sm border border-gray-200 cursor-pointer hover:bg-gray-100">
                                                            <div className="flex space-x-4">
                                                                <input type="radio"
                                                                    checked={ showScheduleStopEarnings === true } 
                                                                    onChange={() => this.toggleScheduleStopEarnings(true)}
                                                                    value={true}
                                                                    className="form-radio my-auto"
                                                                    /> 
                                                                <div className="my-auto">
                                                                    Schedule a date
                                                                </div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </div>

                                                {(showScheduleStopEarnings === true) &&
                                                    <div className="mt-6 ml-8 grid grid-cols-2 gap-x-6">

                                                        <div className="form-group">
                                                            <label>
                                                                Stop earnings from:
                                                                <span className="form-input-required">*</span>
                                                            </label>
                                                            <input type="date" name="stopEarningFrom" className="form-input" min={moment().format("YYYY-MM-DD")} value={nullToEmpty(manageEarningsParams.stopEarningFrom)} onChange={this.formChangeManageEarnings} />
                                                        </div>

                                                        <div className="form-group">
                                                            <label>
                                                                Stop earnings until:
                                                            </label>
                                                            <input type="date" name="stopEarningTo" className="form-input" min={moment().format("YYYY-MM-DD")} value={nullToEmpty(manageEarningsParams.stopEarningTo)} onChange={this.formChangeManageEarnings} />
                                                        </div>

                                                    </div>
                                                }
                                            </div>
                                        }


                                    </div>
                                    
                                    <div className="mt-6 flex justify-end space-x-2">
                                        <button onClick={() => this.props.handleToggleManageEarnings(false)} className="btn btn-transparent-black">Close</button>
                                        <button type="submit" className="btn btn-ep-primary" disabled={employeeStopEarningsLoading || employeeResumeEarningsLoading}>
                                            <FontAwesomeIcon icon="circle-notch" spin className={"text-xl mr-2 " + (employeeStopEarningsLoading || employeeResumeEarningsLoading ? "inline":"hidden")} />
                                            Update
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Dialog>
                }




            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    employeeStopEarningsLoading: state.entities.employees.employeeStopEarningsLoading,
    employeeResumeEarningsLoading: state.entities.employees.employeeResumeEarningsLoading,
});

const mapDispatchToProps = (dispatch) => ({
    stopEmployeeEarning: (employee_id, params) => dispatch(employees.stopEmployeeEarning(employee_id, params)),
    resumeEmployeeEarning: (employee_id) => dispatch(employees.resumeEmployeeEarning(employee_id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);